import { createContext } from "react";

export interface ScholarshipFormContextType {
  openForm: () => void;
}

export const ScholarshipFormContext = createContext<ScholarshipFormContextType>({
  openForm: () => {
    // Default empty function
  },
});
